import { caaMetricsRepositoryAdapter } from '../../infra/repositories/caaMetricsRepositoryAdapter'

export function GetPatientCAAMetricsYearCase(
  repository: ReturnType<typeof caaMetricsRepositoryAdapter>
) {
  return async (params: {
    patientId: string
    personaName?: string
    year: number
  }) => {
    return await repository.getPatientCAAMetricsYear(params)
  }
}
